/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* =============================================================================
   RECHARGE — Fix widget on variant change (main product page)

   Two separate problems require two separate fixes:

   PROBLEM 1 — cart subscription meta (original 2026-04-20 fix):
   Venue 18 replaces the entire <product-form> element on every variant change,
   orphaning ReCharge's cart-submission listeners on the old form. The
   MutationObserver detects the replacement and reinsertes the widget so its
   connectedCallback re-runs and re-attaches those listeners to the new form.

   PROBLEM 2 — subscription price display not updating on size change:
   The widget element has a `default-variant-id` attribute baked in by Shopify
   at page render. Its connectedCallback reads this to fetch subscription
   pricing from ReCharge's API and renders the price. The widget caches its
   initialized state, so reinserting the same element does not cause it to
   re-fetch — subsequent connectedCallback calls are no-ops. Simply patching
   the attribute before reinsert (tried and confirmed not working) therefore
   has no effect.

   Fix: on each variant change, fetch a fresh copy of the section HTML rendered
   for the new variant, extract the widget element from it, and swap it in.
   A brand-new element has no cached state; its connectedCallback runs fully,
   reads the server-baked default-variant-id for the correct variant, and
   fetches the right subscription pricing from ReCharge. This is exactly what
   happens on a full page load with ?variant=... in the URL.
   ============================================================================= */
(function () {
  document.querySelectorAll('product-single').forEach(function (productSingle) {

    /* --- Problem 1 fix: MutationObserver for cart listener re-attachment --- */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].tagName === 'PRODUCT-FORM') {
            var rc = productSingle.querySelector('recharge-subscription-widget');
            if (!rc) return;
            var parent = rc.parentElement;
            var next = rc.nextSibling;
            rc.remove();
            next ? parent.insertBefore(rc, next) : parent.appendChild(rc);
            return;
          }
        }
      }
    }).observe(productSingle, { childList: true, subtree: true });

    /* --- Problem 2 fix: fetch fresh widget element on variant change --- */
    var variantSelector = productSingle.querySelector(
      'variant-selects, variant-radios, variant-mixed-inputs'
    );
    if (!variantSelector) return;

    var sectionId = variantSelector.dataset.section;
    var productUrl = variantSelector.dataset.url;

    variantSelector.addEventListener('on:variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !sectionId || !productUrl) return;

      // Fetch the section rendered for the new variant. Shopify bakes the
      // correct default-variant-id into the fresh widget element, so when
      // connectedCallback runs on the replacement element it fetches the right
      // subscription pricing from ReCharge automatically.
      fetch(productUrl + '?section_id=' + sectionId + '&variant=' + variant.id)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRc = doc.querySelector('recharge-subscription-widget');
          if (!newRc) return;
          var current = productSingle.querySelector('recharge-subscription-widget');
          if (current) {
            current.replaceWith(newRc);
          }
        })
        .catch(function () { /* network errors are silent; price just stays stale */ });
    });
  });
})();
